import { createStandardAction } from 'typesafe-actions'

export const showMoreLines = createStandardAction('SHOW_MORE_LINES')<number>()
export const showLessLines = createStandardAction('SHOW_LESS_LINES')<number>()
export const flipSortOrder = createStandardAction('FLIP_SORT_ORDER')<undefined>()
